import fetch from 'isomorphic-fetch';
import {API2_URL, AXIS_REQUEST, AXIS_SHOW, AXIS_EDIT, AXIS_CLEAR, AXIS_FAIL} from "../store/config";
import { newNotification } from "./notifications";
import _ from 'lodash';
import {sessionService} from "redux-react-session";
import {history} from "../store/store";
import {statusGroupList} from "./status";

export const axisShow = (page=1, filters={}) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				let params = '';
				_.mapKeys(filters, (value, key) => {
					if(value){
						params = `${params}&${key}=${value}`;
					}
				});

				dispatch(axisRequest());
				return fetch(`${API2_URL}/proigualdad/axis?page=${page}${params}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(axisData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(axisFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const axisList = (status_id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(axisRequest());
				return fetch(`${API2_URL}/proigualdad/axis?per_page=all${ !isNaN(status_id) ? '&status_id='+status_id : '' }`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(axisData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(axisFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const axisEdit = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			dispatch(axisRequest());
			dispatch(axisClear());



			return dispatch(statusGroupList())
				.then((status) => {
					if(!_.isEmpty(status.payload)){

						return fetch(`${API2_URL}/proigualdad/axis/${id}`, options)
							.then(result => {
								if (result.status >= 200 && result.status < 300) {
									return result.json();
								} else {
									return result.json().then(Promise.reject.bind(Promise));
								}
							})
							.then(
								json => dispatch(axisEditData(json)),
								error => {
									dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
									return dispatch(axisFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
								}
							)

					}else {
						return dispatch(axisFail('Carga incompleta'))
					}
				})
		})
}

export const axisEditSave = (values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(values)
			};

			dispatch(axisRequest());
			return fetch(`${API2_URL}/proigualdad/axis${values.id ? `/${values.id}?_method=PUT`:''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El eje se ha guardado correctamente", type: "success"}));
						if(_.isEmpty(values.id)){
							history.push(`/proigualdad/ejes/editar/${json.data.id}`);
						}
						return dispatch(axisEditData(json))
					},
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(axisFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const axisDelete = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'delete'
			};

			dispatch(axisRequest());
			return fetch(`${API2_URL}/proigualdad/axis/${id}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El eje se ha borrado correctamente", type: "success"}));
						dispatch(axisShow())
					},
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(axisFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const axisData = (json) => {
	return {
		type: AXIS_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const axisEditData = (json) => {
	return {
		type: AXIS_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const axisRequest = () => {
	return {
		type: AXIS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

const axisClear = () => {
	return {
		type: AXIS_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
}

const axisFail = (error) => {
	return {
		type: AXIS_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/axis.js